"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PairedView = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _verticalView = require("../item-view/vertical-view");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PairedView = function PairedView(_ref) {
  var _images$, _images$2, _images$3, _images$4, _images$5, _images$6, _images$7, _images$8;

  var setDropOffsetRef = _ref.setDropOffsetRef,
      setDropInBetween = _ref.setDropInBetween,
      isHalfTheme = _ref.isHalfTheme,
      isCroppedTheme = _ref.isCroppedTheme,
      isDarkTheme = _ref.isDarkTheme,
      _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images,
      headline1Color = _ref.headline1Color,
      headline2Color = _ref.headline2Color,
      btnColor = _ref.btnColor;
  var headline1ColorHalfTheme = isHalfTheme ? 'gray800' : headline1Color;
  var headline2ColorHalfTheme = isHalfTheme ? 'gray800' : headline2Color;
  var btnColorHalfTheme = isHalfTheme ? 'gray800' : btnColor;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_uiKit.Row, null, /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    col: 12
  }, ((_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.fileReference) && /*#__PURE__*/_react.default.createElement(_verticalView.VerticalView, _extends({}, images[0], {
    renditionSrc: (_images$2 = images[0]) === null || _images$2 === void 0 ? void 0 : _images$2.fileReference,
    headline1Color: headline1ColorHalfTheme,
    headline2Color: headline2ColorHalfTheme,
    boxPadding: [0, 0, 60],
    hideText: true,
    btnColor: btnColor
  })), ((_images$3 = images[3]) === null || _images$3 === void 0 ? void 0 : _images$3.fileReference) && /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    mt: 90,
    mr: 36
  }, /*#__PURE__*/_react.default.createElement(_verticalView.VerticalView, _extends({}, images[3], {
    renditionSrc: (_images$4 = images[3]) === null || _images$4 === void 0 ? void 0 : _images$4.fileReference,
    headline1Color: headline1Color,
    headline2Color: headline2Color,
    hideText: true,
    btnColor: isCroppedTheme && isDarkTheme ? 'gray800' : btnColor,
    setRef: setDropInBetween
  })))), /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    col: 12
  }, ((_images$5 = images[1]) === null || _images$5 === void 0 ? void 0 : _images$5.fileReference) && /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    pl: 60
  }, /*#__PURE__*/_react.default.createElement(_verticalView.VerticalView, _extends({}, images[1], {
    renditionSrc: (_images$6 = images[1]) === null || _images$6 === void 0 ? void 0 : _images$6.fileReference,
    headline1Color: headline1ColorHalfTheme,
    headline2Color: headline2ColorHalfTheme,
    boxPadding: [0, 0, 60],
    btnColor: btnColorHalfTheme,
    setRef: setDropOffsetRef
  }))), ((_images$7 = images[2]) === null || _images$7 === void 0 ? void 0 : _images$7.fileReference) && /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    pl: 24
  }, /*#__PURE__*/_react.default.createElement(_verticalView.VerticalView, _extends({}, images[2], {
    renditionSrc: (_images$8 = images[2]) === null || _images$8 === void 0 ? void 0 : _images$8.fileReference,
    headline1Color: isCroppedTheme && isDarkTheme ? 'white' : headline1Color,
    headline2Color: isCroppedTheme && isDarkTheme ? 'white' : headline2Color,
    btnColor: isCroppedTheme && isDarkTheme ? 'gray800' : btnColor
  }))))));
};

exports.PairedView = PairedView;